module.exports = __webpack_public_path__ + "static/media/ardefinition.033dd823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ardefinition.png
// module id = 952
// module chunks = 0